import axios from "@/hooks/requests/configRequest";
import { I_AXIOS } from "@/hooks/requests/configRequest.model";
import { I_HowYouRateDevice } from "@/stores/howYouRateDevice/howYouRateDevice.types";

import { I_API_GET_QUESTIONS_PAYLOAD } from "./types";

export const apiGetFirstQuestions = async (data: I_API_GET_QUESTIONS_PAYLOAD) => {
    const fetchData = await axios.get<I_HowYouRateDevice["questionData"]>(
        I_AXIOS.STAGE_API_HOST +
            `/api/tin/v1/site/quest/question?ans${data.ans}&token=${data.token}&deviceId=${data.deviceId}&c=${data.c}&questionId=${data.questionId}&lang=${data.lang}`,
    );
    return fetchData.data;
};
